import React from 'react'

import './filters.style.css'

// TODO: Как скролить влево/вправо если мы в режиме desktop а не mobile.

export interface Props {
  children: React.FC<{ values?: any; onSelect?: <T>(value: T[]) => void }>
}

export const FiltersWheel: React.FC<
  React.PropsWithChildren<{ values?: any; onSelect?: () => void }>
> = ({ children }) => (
  <div className="filter-wheel">
    <div className="filter-wheel__container">{children}</div>
  </div>
)
